module.exports = __webpack_public_path__ + "static/img/index-time.e38c642.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/index-time.png
// module id = 6EcY
// module chunks = 1